import React from 'react';
import MethodBtn from '../common/MethodBtn';
import { slaves } from '../../services/ApiService';
import { FMessage } from '../../hoc/IntlComponents';

const DeleteMebmerIconBtn = ({customAction, params}) =>
    <MethodBtn
      btnLabelId='slaves.btn.delete-member'
      api={slaves}
      method='deleteSlave'
      params={params}
      withModal
      modalProps={{
        body: <FMessage id='slaves.delete-member.question'/>,
      }}
      isIcon
      iconProps={{
        className: 'delete-icon',
        type: 'trash'
      }}
      customAction={customAction}
    />;

export default DeleteMebmerIconBtn;